import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    gap: '8px',
    backgroundColor: theme.palette.background.dark || 'rgba(0,0,0,0.04)',
    padding: '4px',
    borderRadius: '8px',
  },
  toggleButton: {
    minWidth: '40px',
    width: '40px',
    height: '32px',
    borderRadius: '6px',
    padding: 0,
    transition: 'all 0.2s ease-in-out',
  },
  activeButton: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    boxShadow: theme.shadows[1],
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  inactiveButton: {
    backgroundColor: 'transparent',
    color: theme.palette.text.secondary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover || 'rgba(0, 0, 0, 0.04)',
    },
  },
}))
